import { SVGProps } from 'react';

export function Warehouse(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <rect
        width='24'
        height='24'
        rx='2'
        fill='#FCFFE6'
      />
      <path
        d='M5.33325 18.667H18.6666'
        stroke='#7CB305'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.96655 18.6665L5.99989 10.6465C5.99989 10.2398 6.19322 9.8532 6.51322 9.59987L11.1799 5.96652C11.6599 5.59319 12.3332 5.59319 12.8199 5.96652L17.4866 9.59319C17.8132 9.84653 17.9999 10.2332 17.9999 10.6465V18.6665'
        stroke='#7CB305'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinejoin='round'
      />
      <path
        d='M14.3334 11.333H9.66675C9.11341 11.333 8.66675 11.7797 8.66675 12.333V18.6663H15.3334V12.333C15.3334 11.7797 14.8867 11.333 14.3334 11.333Z'
        stroke='#7CB305'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.6667 14.833V15.833'
        stroke='#7CB305'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11 9H13'
        stroke='#7CB305'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
